var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 288 l0 -175 53 -7 c30 -3 73 -12 95 -20 37 -13 47 -13 84 0 22 8 65 17 95 20 l53 7 0 175 0 175 -53 -7 c-30 -3 -73 -12 -95 -20 -37 -13 -47 -13 -84 0 -22 8 -65 17 -95 20 l-53 7 0 -175z m143 130 l37 -11 0 -155 0 -154 -22 6 c-13 4 -49 12 -80 18 l-58 12 0 154 0 155 43 -7 c23 -4 59 -12 80 -18z m217 -131 l0 -153 -57 -12 c-32 -6 -68 -14 -80 -18 l-23 -6 0 156 c0 86 3 156 8 156 4 1 30 7 57 15 101 28 95 37 95 -138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 241 l0 -168 68 -7 c37 -3 88 -13 115 -21 41 -12 53 -12 95 0 26 8 77 18 115 21 l67 7 0 168 c0 106 -4 169 -10 169 -6 0 -10 -60 -10 -159 l0 -159 -62 -7 c-35 -4 -82 -13 -105 -20 -35 -11 -51 -11 -85 0 -24 7 -71 16 -105 20 l-63 7 0 159 c0 99 -4 159 -10 159 -6 0 -10 -63 -10 -169z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b01f22fb9cb084b825c1e6c1c3dc5aa4.svg";
export { ForwardRef as ReactComponent };